const isRocket = process.env.CPA_ENV === 'rocket';

const regions = {
	europe: [
		'2921044',
		'146669',
		'2635167',
		'3017382',
		'390903',
		'3175395',
		'2510769',
		'798544',
		'798549',
		'2750405',
		'2802361',
		'3077311',
		'2264397',
		'2661886',
		'719819',
		'6290252',
		'2782113',
		'2658434',
		'732800',
		'2623032',
		'660013',
		'3057568',
		'2963597',
		'3144096',
		'3202326',
		'617790',
		'597427',
		'783754',
		'3277605',
		'718075',
		'3190538',
		'458258',
		'453733',
		'3194884',
		'2960313',
		'2562770',
		'2629691',
		'3041565',
		'2993457',
		'3042058',
		'3168068'
	],
	latin: [
		'3469034',
		'3996063',
		'3686110',
		'3865483',
		'3932488',
		'3625428',
		'3895114',
		'3595528',
		'3658394',
		'3562981',
		'3923057',
		'3723988',
		'3508796',
		'3608932',
		'3437598',
		'3585968',
		'3617476',
		'3624060',
		'3703430',
		'3439705',
		'3489940',
		'3573591',
		'3378535',
		'3382998',
		'3572887',
		'3582678',
		'3374084',
		'3576468',
		'3577815',
		'3580239',
		'3576396',
		'3575830',
		'3575174'
	],
	cis: [
		'587116',
		'174982',
		'630336',
		'614540',
		'1522867',
		'1527747',
		'617790',
		'2017370',
		'1220409',
		'1218197',
		'690791',
		'1512440'
	],
	asia: [
		'1814991',
		'1269750',
		'1643084',
		'1210997',
		'1861060',
		'1694008',
		'1562822',
		'1733045',
		'1282988',
		'1873107',
		'1835841',
		'1227603',
		'1831722',
		'294640',
		'1655842',
		'272103',
		'1880251',
		'2029969',
		'1252634',
		'1282028',
		'1819730',
		'298795',
		'1605651',
		'1327865',
		'1821275',
		'1820814',
		'1668284'
	],
	arab: [
		'289688',
		'290291',
		'290557',
		'6254930',
		'1168579',
		'1149361',
		'286963',
		'285570',
		'248816',
		'163843',
		'130758',
		'102358',
		'99237',
		'69543'
	]
};

if (isRocket) {
	regions.asia = [...regions.asia, ...regions.arab];
	delete regions.arab;
	regions.africa = ['248816', '102358', '290291', '2328926', '99237', '286963'];
	regions.asia = regions.asia.filter((id) => !regions.africa.includes(id));
} else {
	regions.africa = ['2328926'];
	delete regions.cis;
}

const locale = {
	en: regions
};
module.exports = {
	regionCodes: {
		cis: ['AM', 'AZ', 'GE', 'MD', 'BY', 'TM', 'TJ', 'UZ', 'KZ', 'KG', 'RU', 'UA']
	},
	enum: regions,
	locale,
	regions: Object.keys(regions)
};



// WEBPACK FOOTER //
// ./enums/regions.js